type PageSectionProps = {
	children: React.ReactNode;
	className?: string;
	/** Usa tutta la larghezza utile su schermi larghi (es. griglie a 3 colonne) */
	wide?: boolean;
};

export default function PageSection({
	children,
	className = "",
	wide = false,
}: PageSectionProps) {
	return (
		<section
			className={`py-8 sm:py-10 lg:py-12 px-4 sm:px-8 lg:px-12 ${className}`}
		>
			<div
				className={`mx-auto w-full ${wide ? "max-w-[1400px]" : "max-w-7xl"}`}
			>
				{children}
			</div>
		</section>
	);
}
